<template>
  <fmv-drawer id="school-filters" align="end">
    <school-filters-sidebar></school-filters-sidebar>
  </fmv-drawer>
</template>

<script>
import { FmvDrawer } from 'fmv-layout';
import SchoolFiltersSidebar from './SchoolFiltersSidebar.vue';

export default {
  name: 'SchoolFilters',

  components: { FmvDrawer, SchoolFiltersSidebar },

  data() {
    return {};
  },

  computed: {},

  methods: {},

  async mounted() {},
};
</script>
